(function () {
    "use strict";

    const CART_ATTRIBUTE_KEY = "cfy_payment_intent";
    const VALUE_PREPAID = "prepaid";
    const VALUE_MANUAL = "manual";
    const WIDGET_CLASS = "cfy-payment-options-widget";
    const CART_MUTATING_URLS = [window.CFY_CART_ADD_URL, window.CFY_CART_CHANGE_URL, window.CFY_CART_UPDATE_URL, window.CFY_CART_CLEAR_URL];
    const CART_DEBOUNCE_MS = 400;
    const ANCHOR_POLL_MS = 600;
    const ANCHOR_TIMEOUT_MS = 15000;
    const INSTALLMENTS = 3;

    if (!window.CFY_PAYMENT_CONFIG) {
        clearStaleAttribute();
        return;
    }

    if (!window.CFY_DISCOUNT_ACTIVE) {
        clearStaleAttribute();
        return;
    }


    const CONFIG = window.CFY_PAYMENT_CONFIG || {};
    const MIN_ORDER_VALUE =
        (window.CFY_MIN_ORDER_VALUE != null && window.CFY_MIN_ORDER_VALUE !== "")
            ? parseFloat(window.CFY_MIN_ORDER_VALUE) * window.Shopify.currency.rate
            : null;

    const style = CONFIG.style || "selection";
    const buttonTextMatch = CONFIG.button_text_match || "Checkout, Check out";
    const selectorOverride = (CONFIG.selector || "").trim();
    const customClass = (CONFIG.custom_class || "").trim();
    const heading = CONFIG.heading;
    const discountLabel = CONFIG.discount_option_label || "Pay now & save";
    const discountLabelSubtext = "Cash 10 discount is automatically applied";
    const otherLabel = CONFIG.other_option_label || "Cash on Delivery";
    const otherLabelSubtext = "Cash 10 discount cannot be used with Koko/Mint/Payzy";
    const buttonLabel = CONFIG.button_label || "Pay now & save";
    const defaultOption = CONFIG.default_option === VALUE_PREPAID ? VALUE_PREPAID : VALUE_MANUAL;

    const buttonTextCandidates = buttonTextMatch
        .split(",")
        .map((s) => s.trim().toLowerCase())
        .filter(Boolean);

    const mountedWidgets = new WeakMap();

    const anchorList = [];

    let currentValue = null;
    let cartTotal = null;
    let cartOriginalTotal = null;
    let cartDebounceTimer = null;
    let cartWritePending = false;

    function clearStaleAttribute() {
        if (window.CFY_CART_ATTRIBUTE) {
            fetch(window.CFY_CART_UPDATE_URL+".js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ attributes: { [CART_ATTRIBUTE_KEY]: "" } }),
            });
        }
    }

    async function fetchCart() {
        try {
            const res = await fetch(window.CFY_CART_URL+".js", {
                headers: { "Content-Type": "application/json" }
            });
            if (!res.ok) throw new Error("cart fetch failed");
            return res.json();
        } catch (e) {
            console.warn("[CFY] Could not fetch cart:", e);
            return null;
        }
    }

    async function writeCartAttribute(value) {
        try {
            cartWritePending = true;
            const res = await fetch(window.CFY_CART_UPDATE_URL+".js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ attributes: { [CART_ATTRIBUTE_KEY]: value } }),
            });

            const cart = await res.json();

            document.dispatchEvent(new CustomEvent("cfy:cart-attribute-updated", {
                bubbles: true,
                detail: {
                    key: CART_ATTRIBUTE_KEY,
                    value: value,
                    cart: cart,
                },
            }));
        } catch (e) {
            console.warn("[CFY] writeCartAttribute error:", e);
        } finally {
            cartWritePending = false;
        }
    }

    function debouncedWrite(value) {
        clearTimeout(cartDebounceTimer);
        cartDebounceTimer = setTimeout(() => {
            writeCartAttribute(value);
        }, CART_DEBOUNCE_MS);
    }

    (function interceptFetch() {
        const _originalFetch = window.fetch.bind(window);

        window.fetch = async function cfyFetchProxy(input, init) {
            const url = (typeof input === "string" ? input : input?.url) || "";
            const pathname = url.replace(/^https?:\/\/[^/]+/, "").split("?")[0];

            const isCartMutation = CART_MUTATING_URLS.some((u) => pathname.startsWith(u));
            const isOurOwnWrite = isCartMutation && pathname.startsWith(window.CFY_CART_UPDATE_URL) && cartWritePending;

            const response = await _originalFetch(input, init);

            if (isCartMutation && !isOurOwnWrite) {
                response
                    .clone()
                    .json()
                    .then((data) => {
                        const cart = (data && data.total_price != null) ? data : null;
                        onCartMutated(cart);
                    })
                    .catch(() => onCartMutated());
            }

            return response;
        };
    })();

    async function onCartMutated(cart = null) {
        if(!cart) {
            cart = await fetchCart();
            if (!cart) return;
        }

        cartTotal = cart.total_price / 100;

        const belowMin = MIN_ORDER_VALUE !== null && cartTotal < MIN_ORDER_VALUE;

        if (belowMin) {
            clearTimeout(cartDebounceTimer);
            currentValue = null;
            await writeCartAttribute("");
            forEachWidget((widget) => { widget.style.display = "none"; });
        } else {
            forEachWidget((widget) => { widget.style.display = ""; });

            if (currentValue === null && style !== "button") {
                currentValue = defaultOption;
                debouncedWrite(defaultOption);
                syncAll();
            }
        }
    }

    document.addEventListener("cart:updated", () => onCartMutated());
    document.addEventListener("cart:refresh", () => onCartMutated());
    document.addEventListener("sections:load", () => onCartMutated());

    function registerWidget(anchor, widget) {
        mountedWidgets.set(anchor, widget);
        if (!anchorList.includes(anchor)) anchorList.push(anchor);
    }

    function forEachWidget(cb) {
        for (const anchor of anchorList) {
            const widget = mountedWidgets.get(anchor);
            if (widget && document.contains(widget)) cb(widget);
        }
    }

    function syncAllRadios() {
        forEachWidget((widget) => {
            widget.querySelectorAll(".cfy-radio").forEach((radio) => {
                radio.checked = radio.value === currentValue;
            });
            widget.querySelectorAll(".cfy-option").forEach((lbl) => {
                const radio = lbl.querySelector(".cfy-radio");
                lbl.classList.toggle("cfy-checked", !!(radio && radio.checked));
            });
        });
    }

    function syncAll() {
        if (style === "selection") syncAllRadios();
    }

    function setLoading() {
        forEachWidget((widget) => {
            widget.classList.add("cfy-loading");
            widget.querySelectorAll("input, button").forEach((el) => { el.disabled = true; });
        });
    }

    function clearLoading() {
        forEachWidget((widget) => {
            widget.classList.remove("cfy-loading");
            widget.querySelectorAll("input, button").forEach((el) => { el.disabled = false; });
        });
    }

    function buildSelectionWidget() {
        const container = document.createElement("div");
        container.className =
            WIDGET_CLASS + " cfy-selection" + (customClass ? " " + customClass : "");

        if (heading && heading.trim() !== "") {
            const h = document.createElement("p");
            h.className = "cfy-heading";
            h.textContent = heading;
            container.appendChild(h);
        }

        const optionsDiv = document.createElement("div");
        optionsDiv.className = "cfy-options";

        function makeOption(value, label, subtext) {
            const lbl = document.createElement("label");
            lbl.className = "cfy-option" + (currentValue === value ? " cfy-checked" : "");

            const input = document.createElement("input");
            input.type = "radio";
            input.name = "cfy_payment_intent_" + Math.random().toString(36).slice(2, 7);
            input.value = value;
            input.className = "cfy-radio";
            input.checked = currentValue === value;

            input.addEventListener("change", () => {
                if (!input.checked) return;
                currentValue = value;
                syncAll();
                setLoading();

                clearTimeout(cartDebounceTimer);
                cartDebounceTimer = setTimeout(async () => {
                    await writeCartAttribute(value);
                    clearLoading();
                }, CART_DEBOUNCE_MS);
            });

            const span = document.createElement("span");
            span.className = `cfy-option-label cfy_option_label_${value}`;
            
            let lbl_content = label;
            if(cartOriginalTotal) {
                const moneyFormat = document.querySelector(".money_format")?.value ?? Shopify.money_format;
                const payBy = value === 'prepaid' ? 1 : INSTALLMENTS;
                const cartDiscount = value === 'prepaid' ? 10 : 0;
                let cartTotalPrice = cartOriginalTotal;
                cartTotalPrice = cartTotalPrice - (cartTotalPrice * cartDiscount / 100);
                cartTotalPrice = cartTotalPrice / payBy;
                cartTotalPrice = Shopify.formatMoney(cartTotalPrice, moneyFormat);
                lbl_content += ` - <span class="payment_option_price">${payBy === 3 ? "3 x " : ""}${cartTotalPrice}</span>`;
            }
            span.innerHTML = lbl_content;

            const subtextSpan = document.createElement("span");
            subtextSpan.className = "cfy-option-subtext";
            subtextSpan.innerHTML = subtext;

            const lblText = document.createElement("span");
            lblText.className = "cfy-option-text";
            lblText.appendChild(span);
            lblText.appendChild(subtextSpan);

            lbl.appendChild(input);
            lbl.appendChild(lblText);
            return lbl;
        }

        optionsDiv.appendChild(makeOption(VALUE_PREPAID, discountLabel, discountLabelSubtext));
        optionsDiv.appendChild(makeOption(VALUE_MANUAL, otherLabel, otherLabelSubtext));
        container.appendChild(optionsDiv);
        return container;
    }

    function buildButtonWidget() {
        const container = document.createElement("div");
        container.className = WIDGET_CLASS + " cfy-button-style";

        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "cfy-prepaid-btn" + (customClass ? " " + customClass : "");
        btn.textContent = buttonLabel;

        btn.addEventListener("click", async () => {
            setLoading();
            clearTimeout(cartDebounceTimer)
            await writeCartAttribute(VALUE_PREPAID);
            currentValue = VALUE_PREPAID;
            sessionStorage.setItem("cfy_prepaid_pending", "1");
            window.location.href = "/checkout";
        });

        container.appendChild(btn);
        return container;
    }

    function findAllAnchors() {
        if (selectorOverride) {
            return Array.from(document.querySelectorAll(selectorOverride));
        }

        return Array.from(
            document.querySelectorAll('button, input[type="submit"], a[href*="checkout"]')
        ).filter((el) => {
            const text = (el.innerText || el.value || el.textContent || "").trim().toLowerCase();
            return buttonTextCandidates.some((c) => text.includes(c));
        });
    }

    function mountWidget(anchor, hidden = false) {
        const existing = mountedWidgets.get(anchor);
        if (existing && document.contains(existing)) return;

        const widget = style === "button" ? buildButtonWidget() : buildSelectionWidget();
        if (hidden) widget.style.display = "none";
        
        anchor.parentNode.insertBefore(widget, anchor);

        const parentStyle = window.getComputedStyle(anchor.parentNode);
        if (parentStyle.display === "flex" || parentStyle.display === "inline-flex") {
            anchor.parentNode.style.flexWrap = "wrap";
        }

        registerWidget(anchor, widget);
    }

    function mountAll(hidden = false) {
        findAllAnchors().forEach((anchor) => mountWidget(anchor, hidden));
    }

    async function restoreState() {
        const cart = await fetchCart();
        if (!cart) return;

        cartTotal = cart.total_price / 100;
        cartOriginalTotal = cart.original_total_price;

        if(style === "button") {
            await writeCartAttribute("");
            currentValue = null;
        } else {
            const saved = (cart.attributes || {})[CART_ATTRIBUTE_KEY];
            if (saved === VALUE_PREPAID || saved === VALUE_MANUAL) {
                currentValue = saved;
            } else {
                currentValue = defaultOption;
                debouncedWrite(defaultOption);
            }
        }
    }

    function pollAndMount() {
        const started = Date.now();

        const interval = setInterval(async () => {
            const anchors = findAllAnchors();

            if (anchors.length > 0) {
                clearInterval(interval);

                await restoreState();

                const belowMin = MIN_ORDER_VALUE !== null && cartTotal !== null && cartTotal < MIN_ORDER_VALUE;
                if (belowMin) {
                    await writeCartAttribute("");
                    currentValue = null;
                }
                
                mountAll(belowMin);
                observeDOM();

            } else if (Date.now() - started > ANCHOR_TIMEOUT_MS) {
                clearInterval(interval);
                console.warn("[CFY] Checkout button not found within timeout.");
            }
        }, ANCHOR_POLL_MS);
    }

    function remountMissing() {
        const belowMin = MIN_ORDER_VALUE !== null && cartTotal !== null && cartTotal < MIN_ORDER_VALUE;

        for (const anchor of anchorList) {
            const widget = mountedWidgets.get(anchor);
            if (document.contains(anchor) && (!widget || !document.contains(widget))) {
                mountWidget(anchor, belowMin);
            }
        }

        findAllAnchors()
            .filter((a) => {
                const w = mountedWidgets.get(a);
                return !w || !document.contains(w);
            })
            .forEach((a) => mountWidget(a, belowMin));

        syncAll();
    }

    function observeDOM() {
        let mutationDebounce = null;

        const observer = new MutationObserver(() => {
            clearTimeout(mutationDebounce);
            mutationDebounce = setTimeout(remountMissing, 300);
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }

    document.addEventListener("cfy:remount", remountMissing);

    function init() {
        pollAndMount();
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }

    window.addEventListener("pageshow", (e) => {
        if (e.persisted) {
            if(style === "button") {
                const pending = sessionStorage.getItem("cfy_prepaid_pending");
                if(pending) {
                    sessionStorage.removeItem("cfy_prepaid_pending");
                    clearLoading();
                    fetch(window.CFY_CART_UPDATE_URL+".js", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ attributes: { [CART_ATTRIBUTE_KEY]: "" } }),
                    });
                }
            } else {
                syncAll();
            }
        }
    });

    document.addEventListener("cfy:total-price-updated", (e) => {
        cartOriginalTotal = e.detail?.total_price ?? null;
    });
})();

window.cfyUpdatePaymentPrice = function (total_price) {
    const cfy_options = document.querySelectorAll(".cfy-option-label");
    cfy_options.forEach(elem => {
        const moneyFormat = document.querySelector(".money_format")?.value ?? Shopify.money_format;
        const cartDiscount = elem.classList.contains("cfy_option_label_prepaid") ? 10 : 0;

        let cartTotalPrice = total_price;        
        cartTotalPrice = cartTotalPrice - (cartTotalPrice * cartDiscount / 100);
        cartTotalPrice = Shopify.formatMoney(cartTotalPrice, moneyFormat);

        const paymentPrice = elem.querySelector(".payment_option_price");
        if(paymentPrice) {
            paymentPrice.innerHTML = cartTotalPrice;
        } else {
            elem.innerHTML = `${elem.textContent} - <span class="payment_option_price">${cartTotalPrice}</span>`;
        }
    });

    document.dispatchEvent(new CustomEvent("cfy:total-price-updated", {
        bubbles: true,
        detail: {
            total_price
        },
    }));
};